import { types } from '../../../constants/ActionTypes'

const initialState = {
  liveId: null,
}

const liveSettings = (state = initialState, action) => {
  switch (action.type) {
    case types.liveSettings.INIT:
      return { liveId: null }
    case types.live.RECEIVE_LIVE_ID:
      return { ...state, liveId: action.liveId }
    default:
      return state
  }
}

export default liveSettings


// WEBPACK FOOTER //
// ./src/reducers/Page/Live/LiveSettings.js